import { useCredits } from "../contexts/CreditContext";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Banner shown when AI credits drop below 20%.
 * Offers both Upgrade and Buy Credits actions.
 */
export default function LowCreditBanner() {
  const ctx = useCredits();
  const navigate = useNavigate();
  if (!ctx?.isLow || ctx.isExhausted) return null;

  const { monthlyRemaining, purchasedRemaining, total } = ctx;

  return (
    <div
      className="bg-amber-400/10 border border-amber-400/30 rounded-lg p-4 flex items-center justify-between"
      data-testid="low-credit-banner"
    >
      <div className="flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0" />
        <div>
          <p className="font-medium text-sm">Running low on AI credits</p>
          <p className="text-xs text-muted-foreground">
            {monthlyRemaining.toLocaleString()} monthly
            {purchasedRemaining > 0 && ` + ${purchasedRemaining.toLocaleString()} purchased`}
            {" "}of {total.toLocaleString()} credits remaining.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          variant="outline"
          className="border-amber-400/40 text-amber-400 hover:bg-amber-400/10"
          onClick={() => navigate("/buy-credits")}
          data-testid="low-credit-buy-btn"
        >
          Buy Credits
        </Button>
        <Button
          size="sm"
          variant="outline"
          className="border-amber-400/40 text-amber-400 hover:bg-amber-400/10"
          onClick={() => navigate("/pricing")}
          data-testid="low-credit-upgrade-btn"
        >
          Upgrade
        </Button>
      </div>
    </div>
  );
}
